/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Auth_Signup_SuccessInputs */

const cs_auth_signup_success = /** @type {(inputs: Auth_Signup_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Účet založen — vítejte v ${i?.name}`)
};

const en_auth_signup_success = /** @type {(inputs: Auth_Signup_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Account created — welcome to ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Account created — welcome to {name}" |
*
* @param {Auth_Signup_SuccessInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_success = /** @type {((inputs: Auth_Signup_SuccessInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_SuccessInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_success(inputs)
	return cs_auth_signup_success(inputs)
});